import React from 'react';
import { Grid, Skeleton } from '@mui/material';
import { AML_CARD_HEIGHT } from './amlScreeningStyles';

export default function AmlScreeningSkeleton() {
  return <Skeleton variant="rounded" height={420} />;
}
